export default {"src":"/_next/static/media/transfers-own.248292e1.svg","height":100,"width":100};